var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 8C4.25 8.41421 4.58579 8.75 5 8.75C5.41421 8.75 5.75 8.41421 5.75 8H4.25ZM18.25 8C18.25 8.41421 18.5858 8.75 19 8.75C19.4142 8.75 19.75 8.41421 19.75 8H18.25ZM5.75 8V7H4.25V8H5.75ZM7 5.75H17V4.25H7V5.75ZM18.25 7V8H19.75V7H18.25ZM17 5.75C17.6904 5.75 18.25 6.30964 18.25 7H19.75C19.75 5.48122 18.5188 4.25 17 4.25V5.75ZM5.75 7C5.75 6.30964 6.30964 5.75 7 5.75V4.25C5.48122 4.25 4.25 5.48122 4.25 7H5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16C19.75 15.5858 19.4142 15.25 19 15.25C18.5858 15.25 18.25 15.5858 18.25 16L19.75 16ZM5.75 16C5.75 15.5858 5.41421 15.25 5 15.25C4.58579 15.25 4.25 15.5858 4.25 16L5.75 16ZM18.25 16L18.25 17L19.75 17L19.75 16L18.25 16ZM17 18.25L7 18.25L7 19.75L17 19.75L17 18.25ZM5.75 17L5.75 16L4.25 16L4.25 17L5.75 17ZM7 18.25C6.30964 18.25 5.75 17.6904 5.75 17L4.25 17C4.25 18.5188 5.48122 19.75 7 19.75L7 18.25ZM18.25 17C18.25 17.6904 17.6904 18.25 17 18.25L17 19.75C18.5188 19.75 19.75 18.5188 19.75 17L18.25 17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H22",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.6dbf0592c994eacab86d9626befc62c4.svg";
export { ForwardRef as ReactComponent };